import Vue from "vue";

import "vue-multiselect/dist/vue-multiselect.min.css";


import MultiSelect from 'vue-multiselect';
Vue.component("multiselect", MultiSelect);